import { Container } from '@mui/material';
import ChangeNotifyNameDialog from 'components/ChangeNotifyNameDialog';
import IrisCloudBrand from 'components/IrisCloudBrand';
import { PageWrapper, FormContainer } from './elements';
import LoginForm from '../../../components/forms/Auth/LoginForm';

const SignIn = () => (
  <PageWrapper>
    <Container maxWidth="sm">
      <FormContainer>
        <IrisCloudBrand />
        <LoginForm />
        <ChangeNotifyNameDialog />
      </FormContainer>
    </Container>
  </PageWrapper>
);

export default SignIn;
